import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';

class Double extends PureComponent {

    static propTypes = {
        content: PropTypes.array
    }

    render() {
        const { content } = this.props;

        return (
            <div className={styles.double}>
                <div className={styles.doubleList}>
                    {
                        content && content.map((item, index) => {
                            return (
                                <div className={styles.doubleItem} key={index}>
                                    <img src={formatImage(getThumbnail(item), 122, 122)} className={styles.cover} alt="" />
                                    <div className={styles.textPart}>
                                        <h3>
                                            <a href={item.url} target="_blank" rel="noreferrer">{item.title}</a>
                                        </h3>
                                        <p>
                                            {item.summary}
                                            <span className={styles.cRed}><a href={item.url} target="_blank" rel="noreferrer">[详细]</a></span>
                                        </p>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}

export default Double;
